import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ name: 'counter' })
export default class Counter extends VuexModule {
  count = 0;

  @Mutation
  increment(delta: number) {
    this.count += delta;
  }

  @Mutation
  decrement(delta: number) {
    this.count -= delta;
  }

  @Action({ commit: 'increment' })
  incr(delta: number) {
    return delta;
  }

  @Action({ commit: 'decrement' })
  decr(delta: number) {
    return delta;
  }

  get currentCount() {
    return this.count;
  }
}
